import { type Cid, currentDatetimeString } from '@atproto/lex'
import type { AccountDb } from '../db/index.js'

export const updateRoot = async (
  db: AccountDb,
  did: string,
  cid: Cid,
  rev: string,
) => {
  // @TODO balance risk of a race in the case of a long retry
  await db.executeWithRetry(
    db.db
      .insertInto('repo_root')
      .values({
        did,
        cid: cid.toString(),
        rev,
        indexedAt: currentDatetimeString(),
      })
      .onConflict((oc) =>
        oc.column('did').doUpdateSet({ cid: cid.toString(), rev }),
      ),
  )
}
